export class ButtonWithText extends Phaser.GameObjects.Container {

    public enabled: boolean = true;
    
    private originalScale:  number;
    private buttonImage: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene, buttonImage: Phaser.GameObjects.Image, label: Phaser.GameObjects.Text, callback: Function, context: any) {
        
        super(scene);

        buttonImage.setInteractive({ useHandCursor: true });

        buttonImage.on("pointerover", () => { 
            if (this.enabled) {
                this.originalScale = this.scaleX;
                this.setScale(1.025 * this.originalScale);  
            } 
        }, this);
        
        buttonImage.on("pointerout", () => { 
            if (this.enabled) {
                this.setScale(this.originalScale); 
            } 
        }, this);

        buttonImage.on("pointerdown", () => {
            if (this.enabled) {
                callback.apply(context);
            }
        }, this);
        this.add(buttonImage);

        this.buttonImage = buttonImage;

        this.add(label);
    }

    public enable(): void {
        
        this.buttonImage.setInteractive({ useHandCursor: true });
    }

    public disable(): void {
        
        this.buttonImage.disableInteractive();
        this.alpha = .75;
    }
}
